import { render } from "./App.vue?vue&type=template&id=213f7c49"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=213f7c49&lang=scss"

import exportComponent from "D:\\FrontEndMentor Challenges\\Challenges\\Product-Preview-Component\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__